const blockHero = document.querySelector('.block-hero') as HTMLElement;
const heroLinks = document.querySelectorAll('.hero-links__item') as NodeListOf<HTMLElement>;
const defaultImages = document.querySelector('.hero-images__default');

window.addEventListener('load', () => {
	blockHero.classList.remove('block-hero--preload');
});

heroLinks.forEach((link) => {
	link.addEventListener('mouseover', handleMouseOver);
	link.addEventListener('mouseout', handleMouseOut);
});

let lastActiveDivId: string | null = null;
let isMouseOver = false;

function handleMouseOver(this: HTMLElement) {
	const targetImageId = this.getAttribute('data-target');
	defaultImages?.classList.add('image-hidden');

	if (targetImageId) {
		const targetDiv = document.getElementById(targetImageId);
		targetDiv?.classList.add('image-active');

		if (lastActiveDivId !== null && lastActiveDivId !== targetImageId) {
			const lastActiveDiv = document.getElementById(lastActiveDivId);
			lastActiveDiv?.classList.remove('image-active');
		}

		lastActiveDivId = targetImageId;
		isMouseOver = true;
	}
}

function handleMouseOut(this: HTMLElement) {
	const targetImageId = this.getAttribute('data-target');
	defaultImages?.classList.remove('image-hidden');
	isMouseOver = false;

	if (targetImageId) {
		const targetDiv = document.getElementById(targetImageId);
		setTimeout(() => {
			if (isMouseOver === false) {
				targetDiv?.classList.remove('image-active');
			}
		}, 2000);
	}
}
